import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../base_url';
import { PuffLoader } from 'react-spinners';
import { MDBDataTable } from 'mdbreact';


const LocationTax = () => {
    const [loading, setLoading] = useState(false);
    const [rowDetails, setRowDetails] = useState([])
    const data = {
        columns: [
            {
                label: 'S.No',
                field: 'id',
            },
            {
                label: 'Location',
                field: 'location',
            },
            {
                label: 'Tax1',
                field: 'tax1',
            },
            {
                label: 'Tax2',
                field: 'tax2',
            },
        ],
        rows: rowDetails
    };
    useEffect(() => {
        taxDetails();
    },[])

    const taxDetails = () => {
        setLoading(true);
        axios.get(baseURL + "/get_location_tax_details")
        .then((res) => {
            var j = 1;
            let rowsData = [];
            const myDataSet = res.data;
            for (var index = 0; index < res.data.length; index++) {
              let rowItem = {};
              const val = myDataSet[index];
              rowItem["id"] = j;
              rowItem["location"] = val.location;
              rowItem["tax1"] = val.tax1;
              rowItem["tax2"] = val.tax2;
              rowsData.push(rowItem)
              j++;
            }
            setRowDetails(rowsData);
            setLoading(false);
        });
    }
    return(
        <div className='body_class'>
        {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
        ) : ("")}
            <div className='container-fluid'>
                <h4>Location Tax</h4>
                <div className='mt-4'>
                    <div className='container-fluid'>
                        <div className="row mt-1">
                            <div className="col-md-8">
                                <MDBDataTable
                                    bordered
                                    data={data}
                                    large={false}
                                    displayEntries={false}
                                    search={true}
                                    noBottomColumns={true}
                                    className="pagination-right-aligned"
                                    searching={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     )  
}

export default LocationTax;